import { message, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import {
	useAddKurultaiRegisterMutation,
	useDeleteKurultaiRegisterMutation,
	useEditKurultaiRegisterMutation,
} from '../../../redux/api/kurultai/kurultaiRegisterApi'
import { getCookie } from 'typescript-cookie'
import { EntKurultaiRegister } from '../../../models/kurultai/kutultaiRegister'

const useKurultaiRegister = (modal: any, refresh?: () => void) => {
	const { t } = useTranslation()
	const { confirm } = modal
	const [addKurultaiRegister] = useAddKurultaiRegisterMutation()
	const [deleteKurultaiRegister] = useDeleteKurultaiRegisterMutation()
	const [editKurultaiRegister] = useEditKurultaiRegisterMutation()

	async function onAddKurultaiRegister(newKurultaiRegister: EntKurultaiRegister): Promise<boolean> {
		try {
			let status: boolean = false
			await addKurultaiRegister(newKurultaiRegister)
				.then((response: any) => {
					if (response.error !== undefined) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						message.success(t('msg.successAdd'))
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	async function onDeleteKurultaiRegister(kurultaiRegister: EntKurultaiRegister) {
		try {
			let status: boolean = false
			confirm({
				centered: true,
				title: t('msg.confirmDeleteText'),
				okText: t('general.yes'),
				cancelText: t('general.no'),
				onOk() {
					deleteKurultaiRegister(kurultaiRegister.id as number)
						.then((response: any) => {
							if (response.error) {
								const isKyrgyz = getCookie('i18next') === 'ky'
								const lang = isKyrgyz ? 'kg' : 'ru'
								const res = response.error.data?.res
								const errorMessages = Array.isArray(res)
									? res.map((error: any) => error[lang] || error.ru).join('\n')
									: response.error.data?.msg || t('unknownError')
								throw new Error(errorMessages)
							}
							if (response.data.success) {
								status = true
								Modal.success({ title: t('msg.successDelete') })
								if (refresh) refresh()
							}
						})
						.catch((error: any) => {
							Modal.error({ title: t('msg.error'), content: String(error.message) })
						})
				},
			})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	async function onEditKurultaiRegister(
		editedKurultaiRegister: EntKurultaiRegister
	): Promise<boolean> {
		try {
			let status: boolean = false
			await editKurultaiRegister(editedKurultaiRegister)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						Modal.success({ title: t('msg.successEdited') })
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					Modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	return { onAddKurultaiRegister, onDeleteKurultaiRegister, onEditKurultaiRegister }
}

export { useKurultaiRegister }
